module.exports = __webpack_public_path__ + "static/replit-dcd014f2a5fcec7768f9ca2d5fed3354.png";